import { lazyPopoutMailReadingPaneUtil } from 'owa-mail-popout-reading-pane/lib/lazyFunctions';
import { popoutProjectionMountedPromise } from 'owa-popout-v2/lib/store/parentStore';
import { convertRestIdToEwsId } from 'owa-identifiers';

export interface MailReadRouteParameters {
    itemId?: string;
}

export default async function mailReadRouteHandler(
    parameters: MailReadRouteParameters
): Promise<void> {
    const itemId = parameters.itemId;

    if (itemId) {
        // Wait for projections to be ready
        await popoutProjectionMountedPromise;

        // Decode the encoded item id from the URL
        const decodedEwsId = convertRestIdToEwsId(decodeURIComponent(itemId));

        // Call the popout mail reading pane util directly to ensure packages are loaded
        await lazyPopoutMailReadingPaneUtil.importAndExecute(
            decodedEwsId,
            undefined /*conversationId*/,
            undefined /*internetMessageId*/,
            undefined /*mailboxInfo*/,
            undefined /*data*/,
            undefined /*freezeDryId*/
        );
    }
}
